import { makeStyles } from "@material-ui/core";
import Button from "@mui/material/Button";
import logo from "../../../assets/Images/PickaaGoLogo.png";
import { SingleInputField } from "../../../components";
import { PloginData } from "../../../assets/lib/plogin";
import { useNavigate } from "react-router-dom";
import { routes } from "../../../routing/routes";

const useStyles = makeStyles(() => ({
  wrapper: {
    position: "relative",
    height: "100vh",
    width: "100%",
    overflow: "hidden",
  },
  contentWrapper: {
    position: "relative",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "20px",
    flexDirection: "column",
  },
  logo: {
    width: "160px",
  },
  formCard: {
    backgroundColor: "rgba(255, 255, 255)",
    backdropFilter: "blur(10px)",
    borderRadius: "12px",
    padding: "40px 30px",
    maxWidth: "400px",
    width: "100%",
    boxShadow: "0 10px 30px rgba(0, 0, 0, 0.15)",
    marginTop: "-190px", // ⬅️ Match signup positioning
  },
  heading: {
    fontSize: "20px",
    fontWeight: "bold",
    marginBottom: "5px",
    color: "#880E4F",
    marginLeft:"0px",
    fontFamily: "Inter",

  },
  subheading: {
    fontSize: "14px",
    color: "#555",
    marginBottom: "25px",
    fontWeight: 500,
    marginLeft:"0px",   
     fontFamily: "Inter",


  },
  inputContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    marginBottom: "20px",
    backgroundColor: "rgba(255, 255, 255, 0.2)",
  },
  button: {
    backgroundColor: "#880E4F",
    color: "#fff",
    width: "40%",
    padding: "10px",
    fontWeight: 600,
    borderRadius: "8px",
    marginLeft: "120px", // ⬅️ align button like signup
  },
  footer: {
    fontSize: "14px",
    marginTop: "20px",
    textAlign: "center",
    color: "#888",
  },
  forgotLink: {
    color: "#000",
    fontWeight: 600,
    cursor: "pointer",
    marginLeft: "5px",
  },
  errorText: {
    color: "red",
    textAlign: "center",
    marginBottom: "10px",
  },
  transparentInput: {
    '& .MuiInputBase-root': {
      backgroundColor: 'transparent !important',
      border: '1px solid rgba(255, 255, 255, 0.4)',
      color: '#fff',
    },
    '& input': {
      color: '#fff',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'rgba(255, 255, 255, 0.4)',
    },
  },
}));

const Layout = (props) => {
  const {
    loginState,
    errorFields,
    getLoginInput,
    handleLogin,
    loginFailedText,
  } = props;

  const classes = useStyles();
  const navigate = useNavigate();

  return (
    <div className={classes.wrapper}>
      <div style={{ width: "100vw", padding: "10px" }}>
        <img src={logo} alt="PickaaGo Logo" className={classes.logo} />
      </div>

      <div className={classes.contentWrapper}>
        <div className={classes.formCard}>
          <div className={classes.heading}>
            <strong>Redefining the way you receive packages.</strong>
          </div>
          <div className={classes.subheading}>
            Login to your PickaaGo account
          </div>

          {loginFailedText && <div className={classes.errorText}>{loginFailedText}</div>}

          <div className={classes.inputContainer}>
            <SingleInputField
              content={PloginData.phoneNumber}
              value={loginState.phoneNumber}
              getInputData={getLoginInput}
              errorFields={errorFields}
              className={classes.transparentInput}
            />
            <SingleInputField
              content={PloginData.passCode}
              value={loginState.passCode}
              getInputData={getLoginInput}
              errorFields={errorFields}
              className={classes.transparentInput}
            />
          </div>

          <Button
           variant="contained"
           style={{
             backgroundColor: "#880E4F",
             color: "#fff",
             width: "40%",
             padding: "10px",
             fontWeight: 600,
             borderRadius: "8px",
             marginLeft:"120px"
           }}
            className={classes.button}
            onClick={handleLogin}
          >
            Login
          </Button>

          <div className={classes.footer}>
            Forgot your passcode?
            <span
              className={classes.forgotLink}
              onClick={() => navigate(routes.FORGOT_PASSCODE)}
            >
              Reset
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Layout;
